import React from 'react';
import styles from './Carousel.module.css';

const Carousel = ({ children }: any) => {
    return <div className={styles.carousel}>{children}</div>;
};

export default Carousel;
